import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/services/apiService';
import { AuthService } from 'src/services/auth.service';
import { languageService } from 'src/services/language.service';

@Component({
  selector: 'app-sections',
  templateUrl: './sections.component.html',
  styleUrls: ['./sections.component.css']
})
export class SectionsComponent {

  sections:any[]=[];
  sectionId:string|undefined;

  // prod=false;

  colorArr:string[]=[
    'bg-gold-2',
    'bg-maroon',
    'bg-gold',
    'bg-green',
    'bg-blue',
    'bg-red',
    'bg-blue',
    'bg-gold',
    'bg-green',
    'bg-blue',
  ];

  textColorArr:string[]=[
    "text-gold-2",
    'text-maroon',
    'text-gold',
    'text-green',
    'text-blue',
    'text-red',
    'text-blue',
    'text-gold',
    'text-green',
    'text-blue',
  ];

  imagesArr:string[]=[
    '../../assets/images/window.png',
    '../../assets/images/investor.png',
    '../../assets/images/motiviation.png',
    '../../assets/images/build.png',
    '../../assets/images/ease.png',
    '../../assets/images/jordan-star.png',
    '../../assets/images/grievance.png',
    '../../assets/images/invest-box.png',
    '../../assets/images/one-approval.png',
    '../../assets/images/ease.png',
  ];

  currentLanguage:string;

  constructor(private apiService:ApiService,private route: ActivatedRoute
    ,private authService:AuthService,private langSerive:languageService) {

      this.currentLanguage=this.langSerive.getCurrentLanguage();

  }
  
  ngOnInit(): void {

    if (this.route.snapshot.queryParams['SectionId']) {
      this.sectionId = this.route.snapshot.queryParamMap.get('SectionId')!;
      if(this.sectionId!=null){
        var request= this.apiService.get(`categorization/GetSectionsWithEntityId?id=${this.sectionId}`);
        request.subscribe(response=>{
          var data=response.data;
          this.sections=data;
        });
      }else{
        location.href='/Entities';
        return;
      }
    }
  }

  openSection(index:number){

    var catId=0;

    switch(index){
      case 0: 
        catId =14;
        break;
      case 1:
        catId =16;
        break;
      case 2:
        catId =15;
        break;
      case 3:
        catId =19;
        break;
      case 4:
        catId =12;
        break;
      case 5:
        catId =18;
        break;
      case 6:
        catId =21;
        break;
      case 8:
        catId =20;
        break;
      case 9:
        catId =12;
        break;
    };

    window.open(`${environment.oldWebsite}/ar/portal/in?token=${this.authService.getToken()}&model=category&id=${catId}`);
}
  
}